import React from 'react';

import { Flex } from '@chakra-ui/react';

import { NotFoundGeneratedProps } from './NotFound.props';

const NotFoundView = (props: NotFoundGeneratedProps) => <Flex>NotFound</Flex>;

export default NotFoundView;
